import { Alert, Box, Snackbar } from '@mui/material'
import { SnackContext } from 'contexts/SnackContextProvider'
import { SyntheticEvent, useContext } from 'react'

const CustomSnackBar = () => {
  const { snackbarAttributes, setSnackbarAttributes } = useContext(SnackContext)

  return (
    <Box>
      <Snackbar
        sx={{ marginTop: '40px' }}
        autoHideDuration={snackbarAttributes.duration}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarAttributes.open}
        onClose={(event?: SyntheticEvent | Event, reason?: string) => {
          if (reason === 'clickaway') {
            setSnackbarAttributes({ ...snackbarAttributes, open: false })
            return
          }
          setSnackbarAttributes({ ...snackbarAttributes, open: false })
        }}
      >
        <Alert severity={snackbarAttributes.severity} sx={{ width: '80%' }}>
          {snackbarAttributes.message}
        </Alert>
      </Snackbar>
    </Box>
  )
}

export default CustomSnackBar
